// extracted by mini-css-extract-plugin
export default {"header":"FullScreenModal_header__wqZPB","content":"FullScreenModal_content__Nz1gx","footer":"FullScreenModal_footer__oRYSE","footerContent":"FullScreenModal_footerContent__W8mJo"};